<tapestry-icon-button
    class="action-menu-trigger"
    [matMenuTriggerFor]="menu"
    iconName="ellipsis_bold"
    [iconSize]="IconSize.Medium"
    isRoundButton="true"
    trackingName="sellerToolsAccountTableActionMenu"
></tapestry-icon-button>
<mat-menu #menu="matMenu">
    @if (enableAddThirdPartyUsers) {
        <button
            mat-menu-item
            (click)="addThirdPartyUsers()"
            piTesting="sellerToolsAccountAddThirdPartyUsers"
        >
            <div class="menu-item">
                <tapestry-icon name="add_user"></tapestry-icon>
                <span>{{
                    'platform.seller-tools-peek.accounts.action-menu.add-third-party-user-action'
                        | translate
                }}</span>
            </div>
        </button>
    }
    <button
        mat-menu-item
        (click)="deleteAccount()"
        piTesting="sellerToolsAccountDelete"
    >
        <div class="menu-item">
            <tapestry-icon name="trash"></tapestry-icon>
            <span>{{
                'platform.seller-tools-peek.accounts.action-menu.delete-action'
                    | translate
            }}</span>
        </div>
    </button>
</mat-menu>
